import React from "react";
import { FinancingModalTrigger } from "tsi-common-react/src/apps/financing/FinancingModalTrigger";
import { t } from "ttag";

interface IProps {
    classString: string;
}

interface IState {}

// TODO(ssr, LEVEL 1 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 1/10 due to simple wrapper component with no state or lifecycle methods.
export class FinancingModalTriggerCheckNow extends React.Component<
    IProps,
    IState
> {
    render() {
        return (
            <span>
                <FinancingModalTrigger
                    modalType="prequal-app"
                    className={this.props.classString}
                >
                    {t`Check Now`}
                </FinancingModalTrigger>
            </span>
        );
    }
}
